<template>
  <div>
    <template v-if="params.data?.inscripcionesModulos?.length > 0">
      <v-btn class="mb-2" :title="tituloProgramaModulo" x-small outlined @click="mostrarModal">
        {{ textoProgramaModulo }}

        <v-icon small>mdi-information-outline</v-icon>
      </v-btn>

      <span class="mx-2">{{ fechaRegistroProgramaModulo }}</span>
    </template>

    <span v-else>-</span>

    <ModalModulosInscritos ref="modalModulosInscritosRef" :inscripcionesModulos="params.data?.inscripcionesModulos" />
  </div>
</template>

<script>
import { obtenerInscripcionModuloMasAlto } from '../utils/funciones';
import botonModuloActualMixin from '../mixins/boton-modulo-actual.mixin';

export default {
  name: 'BotonModuloActual',
  mixins: [botonModuloActualMixin],
  computed: {
    inscripcionModuloMasAlto() {
      const inscripcionesModulos = this.params.data?.inscripcionesModulos;

      return obtenerInscripcionModuloMasAlto(inscripcionesModulos);
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>